import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cb8d9c96"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "time-list" }
const _hoisted_2 = ["onClick"]

import { getLimitTimeListOptions } from '@/defination/agricultura-loan'
import { withDefaults, ref, watch } from 'vue'
import PopupWrap from '@/components/popup/common-wrap.vue'
import CommonFooterNextButton from '@/components/CommonFooterNextButton.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'limit-time-select',
  props: {
    visible: { type: Boolean, default: false },
    activeKey: { default: '1' }
  },
  emits: ['update:visible', 'update:activeKey'],
  setup(__props: any, { emit: emits }) {

const props = __props as { visible: boolean, activeKey: string };




const timeList = getLimitTimeListOptions()
const popupSelectKey = ref('')

watch(
  () => props.visible,
  () => {
    popupSelectKey.value = props.activeKey
  }
)
function updateShowHandle(visible: boolean) {
  emits('update:visible', visible)
}

function clickHandle(value: string) {
  popupSelectKey.value = value
}

function confirmSelect() {
  emits('update:visible', false)
  emits('update:activeKey', popupSelectKey.value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PopupWrap, {
    show: props.visible,
    "safe-area-inset-bottom": "",
    title: "申请期限",
    headerStyle: {
      backgroundColor: 'white',
    },
    "onUpdate:show": updateShowHandle
  }, {
    default: _withCtx(() => [
      _createElementVNode("ul", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(timeList), (item) => {
          return (_openBlock(), _createElementBlock("li", {
            key: item.value,
            class: "van-hairline--bottom",
            onClick: ($event: any) => (clickHandle(item.value))
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(item.value === popupSelectKey.value ? 'active' : '')
            }, _toDisplayString(item.label), 3)
          ], 8, _hoisted_2))
        }), 128))
      ]),
      _createVNode(CommonFooterNextButton, {
        title: "确定",
        onClick: confirmSelect
      })
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})